import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { AssigTripsService } from 'src/app/component/assigned-trips/assigntrips-service/assigntrips-service';
import { getDistanceFromLatLon } from 'src/app/utils/utils.common';
import { PlannerHelpingService } from './planner-helping-service';
@Injectable({
  providedIn: 'root'
})
export class PlannerGroupService {

  user;
  preData;
  preFleet;
  selectedMapper;
  violation;
  timeCalibration;
  selectedDrivers;
  selectedMethod;
  preDrivers;
  shiftMapper;

  constructor(
    private assigTripsService: AssigTripsService,
    private plannerHelpingService: PlannerHelpingService
  ) { }

  async planTrips(user, preData, preFleet, violation, selectedMapper, selectedDrivers, selectedMethod, timeCalibration, manifestTrips, preDrivers, shiftMapper) {
    this.user = user;
    this.preData = preData;
    this.preFleet = preFleet;
    this.violation = violation;
    this.timeCalibration = timeCalibration;
    this.selectedMapper = selectedMapper;
    this.shiftMapper = shiftMapper;
    this.selectedDrivers = selectedDrivers;
    this.selectedMethod = selectedMethod;
    this.preDrivers = preDrivers

    let planedTrips = {
      trips: [],
      nonCompatible: [],
      compatible: {},
      tripLogs: {},
      driversDistance: {}
    };

    for (let trip of this.preData.trips) {
      if (this.preData.selectedTrips.includes(trip._id)) {
        planedTrips.trips.push(trip);
      }
    }

    //  if (this.timeCalibration && this.timeCalibration !== "none") {
    //     // set pickup and drop off time
    //     for (let trip of planedTrips.trips) {
    //       const distance = await this.calculateDistance(
    //         trip.jobOriginLatitude,
    //         trip.jobOriginLongitude,
    //         trip.jobDestinationLatitude,
    //         trip.jobDestinationLongitude
    //       );

    //          if (distance && distance.duration) {
    //                  if (timeCalibration === "pickup-wise") {
    //                    trip.scheduleTime = moment(trip.appointmentTime).tz(user.timeZone).subtract(distance.duration, 'minutes').toISOString();
    //                  } else {
    //                    trip.appointmentTime = moment(trip.scheduleTime).tz(user.timeZone).add(distance.duration, 'minutes').toISOString();
    //                  }
    //           }
    //     }
    //   }

    if (this.timeCalibration && this.timeCalibration !== "none") {
      if (this.timeCalibration === "pickup-wise") {
        await this.plannerHelpingService.applyPickupWiseCalibration(this.selectedMethod, planedTrips.trips, user);
      } else if (this.timeCalibration === "dropoff-wise") {
        await this.plannerHelpingService.applyDropoffWiseCalibration(this.selectedMethod, planedTrips.trips, user);
      } else {
        await this.plannerHelpingService.applyMemberWiseHybridCalibration(this.selectedMethod, planedTrips.trips, user);
      }
    }


    this.selectedDrivers.sort((a, b) =>
      a.displayName.localeCompare(
        b.displayName
      )
    );

    planedTrips.trips.sort((a, b) => {
      return moment(a.scheduleTime).tz(this.user.timeZone).diff(moment(b.scheduleTime).tz(this.user.timeZone));
    });


    if (manifestTrips && manifestTrips.length) {
      for (let item of manifestTrips) {
        if (await this.selectedDrivers.some(driver => driver._id === item.driver)) {
          if (item.driver) {
            if (!planedTrips.compatible[item.driver]) {
              planedTrips.compatible[item.driver] = {
                driver: preDrivers[item.driver],
                trips: []
              };
            }
            if (item) {
              item.preTrip = true;
              planedTrips.compatible[item.driver].trips.push(item);
            }
          }
        }
      }
    }

    await this.assignTripsToDrivers(planedTrips, selectedDrivers);
    await this.finalizeInterleavedSequences(planedTrips);

    // reset trips array after all planning
    planedTrips.trips = [];

    // Final Output Logs
    for (const driverId in planedTrips.compatible) {
      const data = planedTrips.compatible[driverId];
      if (data.driver) {
        console.log(`Driver: ${data.driver.displayName}`);
        console.log(`Trips IDs: ${data.trips.map(t => t.tripId).join(', ')}`);
        if (data.stops) {
          console.log(`Stops:`, data.stops.map(s => `${s.priority}. [${s.stopType}] Patient: ${s.personName || 'Unknown'} (${s.tripId})`));
        }
      }
    }
    return planedTrips;

  }

  async finalizeInterleavedSequences(planedTrips) {
    for (const driverId in planedTrips.compatible) {
      const driverData = planedTrips.compatible[driverId];
      if (driverData.executedStops) {
        driverData.stops = driverData.executedStops.map((stop, index) => {
          const stopObj = {
            ...stop,
            priority: index + 1,
            // UI expected properties:
            latitude: stop.lat,
            longitude: stop.lon,
            personName: stop.priorityClient ? stop.priorityClient.displayName : '',
            sortType: stop.type === 'P' ? 'pickup' : 'dropoff',
            stopType: stop.type === 'P' ? 'pickup' : 'dropoff',
            scheduledTime: stop.scheduleTime,
            appointmentTime: stop.appointmentTime,
            // estimatedArrivalTime is already set in checkStopBasedPossibility
          };
          return stopObj;
        });

        driverData.trips.forEach(trip => {
          const pickupStop = driverData.stops.find(stop => stop._id === trip._id && stop.stopType === 'pickup');
          const dropoffStop = driverData.stops.find(stop => stop._id === trip._id && stop.stopType === 'dropoff');
          trip.pickupOrder = pickupStop ? pickupStop.priority : null;
          trip.dropOffOrder = dropoffStop ? dropoffStop.priority : null;
        });

        // NEW: Validate appointment times and log status
        this.validateAndLogAppointmentTimes(driverData, driverId);
      }
    }
  }

  /**
   * Validates and logs appointment time compliance for each trip in a driver's route.
   * Used for audit trails and performance tracking.
   *
   * @param {Object} driverData - Driver assignment data with stops and trips
   * @param {String} driverId - Driver ID for logging
   */
  private validateAndLogAppointmentTimes(driverData, driverId) {
    try {
      const appointmentBuffer = 5; // minutes
      const appointmentMetrics = {
        total: 0,
        onTime: 0,
        late: 0,
        tooEarly: 0,
        warnings: []
      };

      driverData.stops.forEach((stop) => {
        if (stop.stopType === 'dropoff') {
          appointmentMetrics.total++;

          const appointmentTime = moment(stop.appointmentTime).tz(this.user.timeZone);
          const estimatedArrival = moment(stop.estimatedArrivalTime).tz(this.user.timeZone);

          const minutesEarly = appointmentTime.diff(estimatedArrival, 'minutes');
          const minutesLate = estimatedArrival.diff(appointmentTime, 'minutes');

          if (minutesEarly > 0 && minutesEarly <= appointmentBuffer) {
            appointmentMetrics.onTime++;
            console.log(
              `✓ ON-TIME: ${stop.personName} - Appointment ${appointmentTime.format('HH:mm')}, ` +
              `Arriving ${minutesEarly}min early (within buffer)`
            );
          } else if (minutesEarly > appointmentBuffer) {
            appointmentMetrics.tooEarly++;
            console.warn(
              `⚠ TOO EARLY: ${stop.personName} - Appointment ${appointmentTime.format('HH:mm')}, ` +
              `Arriving ${minutesEarly}min early`
            );
            appointmentMetrics.warnings.push({
              person: stop.personName,
              type: 'too-early',
              minutes: minutesEarly,
              appointmentTime: appointmentTime.toISOString(),
              estimatedArrival: estimatedArrival.toISOString()
            });
          } else if (minutesLate > 0) {
            appointmentMetrics.late++;
            console.error(
              `✗ LATE: ${stop.personName} - Appointment ${appointmentTime.format('HH:mm')}, ` +
              `Arriving ${minutesLate}min LATE`
            );
            appointmentMetrics.warnings.push({
              person: stop.personName,
              type: 'late',
              minutes: minutesLate,
              appointmentTime: appointmentTime.toISOString(),
              estimatedArrival: estimatedArrival.toISOString()
            });
          }
        }
      });

      // Log summary
      const onTimePercentage = appointmentMetrics.total > 0
        ? ((appointmentMetrics.onTime / appointmentMetrics.total) * 100).toFixed(1)
        : 0;

      console.log(
        `\n📊 APPOINTMENT TIME SUMMARY - Driver: ${driverData.driver.displayName}\n` +
        `  Total Appointments: ${appointmentMetrics.total}\n` +
        `  ✓ On-Time: ${appointmentMetrics.onTime} (${onTimePercentage}%)\n` +
        `  ⚠ Too Early: ${appointmentMetrics.tooEarly}\n` +
        `  ✗ Late: ${appointmentMetrics.late}\n`
      );

      if (appointmentMetrics.warnings.length > 0) {
        console.warn('⚠️ Appointment Issues:', appointmentMetrics.warnings);
      }

    } catch (error) {
      console.error('Error validating appointment times:', error);
    }
  }


  /**
 * Main method to assign trips to drivers.
 *
 * It iterates over trips (sorted by scheduleTime) and:
 * • Checks eligibility for each driver based on shift, fleet, funding, service area, and starting point.
 * • If a trip is from a client that already has an assigned driver (flag-based), it will only consider that driver.
 * • For each candidate driver, it ensures the trip fits into their current route.
 * • Finally, it chooses the best driver (minimizing added travel distance) and assigns the trip.
 *
 * @param {Array} trips - Array of trip objects.
 * @param {Array} drivers - Array of driver objects.
 * @returns {Object} A mapping from driver IDs to arrays of assigned trips.
 */
  async assignTripsToDrivers(planedTrips, drivers) {
    // Create a sorted copy of trips by scheduleTime (ascending).
    const clientDriverMap = {};  // { clientId: driverId } to enforce same-driver assignment for the same client

    for (let trip of planedTrips.trips) {
      // Use the priority client clientId if available; fallback to trip.client.
      const clientId = trip.priorityClient.displayName.toLowerCase();
      let candidateDrivers = [];
      let allDriversNearestTo = {};
      let isSameClient = false;

      if (this.violation && this.violation.prefferedToSameDriver && clientDriverMap[clientId]) {
        isSameClient = true;
        const driver = drivers.find((d) => d._id === clientDriverMap[clientId]);
        if (driver && this.isTripEligibleForDriver(planedTrips, trip, driver)) {
          candidateDrivers.push(driver);
        }
      } else {
        // Otherwise, consider all drivers who are eligible.
        candidateDrivers = drivers.filter((driver) => {
          const result = this.isTripEligibleForDriver(planedTrips, trip, driver);
          return result;
        }
        );
      }

      // Initialize results for this trip to avoid race conditions in parallel checks
      if (!allDriversNearestTo[trip._id]) { allDriversNearestTo[trip._id] = []; }

      // Filter candidate drivers further by checking if the trip can be fit into their route.
      let feasibleDrivers = await this.checkDriverRoutes(planedTrips, candidateDrivers, trip, allDriversNearestTo);

      if (feasibleDrivers.length === 0 && isSameClient) {
        console.warn(`Trip ${trip.tripId}. ${trip.priorityClient.displayName} could not be assigned based on current criteria. Rechecking with other drivers`);
        isSameClient = false;
        //consider all drivers who are eligible.
        candidateDrivers = drivers.filter((driver) => {
          const result = this.isTripEligibleForDriver(planedTrips, trip, driver);
          return result;
        });

        // Filter candidate drivers further by checking if the trip can be fit into their route.
        feasibleDrivers = await this.checkDriverRoutes(planedTrips, candidateDrivers, trip, allDriversNearestTo);
      }

      if (feasibleDrivers.length > 0) {
        // Choose the best driver (minimize extra travel distance).
        const chosenDriver = await this.chooseDriverForTrip(clientDriverMap[clientId], feasibleDrivers, allDriversNearestTo, trip, planedTrips.compatible);
        if (planedTrips.compatible[chosenDriver.driver._id]) {
          const selectedTripDistance = await this.calculateDistance(trip.jobOriginLatitude, trip.jobOriginLongitude, trip.jobDestinationLatitude, trip.jobDestinationLongitude);
          if (!planedTrips.driversDistance[chosenDriver.driver._id]) planedTrips.driversDistance[chosenDriver.driver._id] = 0;
          planedTrips.driversDistance[chosenDriver.driver._id] += selectedTripDistance.distance;

          planedTrips.compatible[chosenDriver.driver._id].trips.push(trip);
          planedTrips.compatible[chosenDriver.driver._id].executedStops = chosenDriver.stops;
        } else {
          planedTrips.compatible[chosenDriver.driver._id] = {
            driver: chosenDriver.driver,
            trips: [trip],
            executedStops: chosenDriver.stops
          }
        }

        // Ensure subsequent trips for the same client are assigned to this driver.
        clientDriverMap[clientId] = chosenDriver.driver._id;
      } else {
        planedTrips.nonCompatible.push(trip);
        console.warn(`Trip ${trip.tripId}. ${trip.priorityClient.displayName} could not be assigned based on current criteria.`);
      }
    };


    return planedTrips;
  }

  /**
   * Check if the driver meets fleet, funding, service area, and starting point requirements.
   *
   * @param {Object} trip - Trip object.
   * @param {Object} driver - Driver object.
   * @param {Number} startingPointThreshold - Maximum acceptable distance (in miles) from the driver's starting point to the trip’s pickup.
   */
  isTripEligibleForDriver(planedTrips, selectedTrip, driver, startingPointThreshold = 10) {

    let isCompatible = false;
    let logs = {};
    // debugger;
    const isFundingSourceWiseExist = this.fundingSourcesWiseTrip(selectedTrip, driver);
    logs = { ...logs, isFundingSourceWiseExist };
    if (isFundingSourceWiseExist) {
      const isDriverShiftWiseExist = this.checkDriverShift(selectedTrip, driver);
      logs = { ...logs, isDriverShiftWiseExist };
      if (isDriverShiftWiseExist) {
        const isServiceAreasWiseExist = this.serviceAreasWiseTrip(selectedTrip, driver);
        logs = { ...logs, isServiceAreasWiseExist };
        if (isServiceAreasWiseExist) {
          const isSpaceTypeWiseExist = this.spaceTypeWiseTrip(selectedTrip, driver);
          logs = { ...logs, isSpaceTypeWiseExist };
          if (isSpaceTypeWiseExist) {
            const isGenderWiseExist = this.genderWiseTrip(selectedTrip, driver);
            logs = { ...logs, isGenderWiseExist };
            if (isGenderWiseExist) {
              if (!planedTrips.driversDistance[driver._id]) planedTrips.driversDistance[driver._id] = 0;
              const isMaxFactor = this.checkTripMaxFactor(planedTrips, driver, planedTrips.driversDistance[driver._id]);
              logs = { ...logs, isMaxFactor };
              if (isMaxFactor) {
                isCompatible = true;
              }
            }
          }
        }
      }
    }
    // // 5. Ensure the driver's starting point is close enough to the trip's pickup location.
    // const { latitude: startLat, longitude: startLon } = driver.startingPointAddress;
    // const { jobOriginLatitude: tripPickupLat, jobOriginLongitude: tripPickupLon } = trip;
    // const distanceFromStart = this.haversineDistance(startLat, startLon, tripPickupLat, tripPickupLon);
    // if (distanceFromStart > startingPointThreshold) {
    //   return false;
    // }

    // create Trip logs
    if (!isCompatible) {
      if (planedTrips.tripLogs[driver._id]) {
        planedTrips.tripLogs[driver._id].reasons.push({
          trip: selectedTrip,
          logs
        });
      } else {
        planedTrips.tripLogs[driver._id] = {
          driver,
          reasons: [{
            trip: selectedTrip,
            logs
          }]
        }
      }
    }

    return isCompatible;
  }

  checkDriverShift(selectedTrip, driver) {
    let isExist = false;
    const start = moment(this.preData.date).tz(this.user.timeZone).startOf('day');
    const end = moment(this.preData.date).tz(this.user.timeZone).endOf('day');

    if (this.shiftMapper[driver._id] && this.shiftMapper[driver._id].shifts && this.shiftMapper[driver._id].shifts.length) {
      const checkTodayShift = this.shiftMapper[driver._id].shifts.find(item => item.day == start.day() && item.isEnabled);
      if (checkTodayShift && checkTodayShift.checkin && checkTodayShift.checkout) {
        start.set({ hour: Number(checkTodayShift.checkin.split(':')[0]), minute: Number(checkTodayShift.checkin.split(':')[1]) });
        end.set({ hour: Number(checkTodayShift.checkout.split(':')[0]), minute: Number(checkTodayShift.checkout.split(':')[1]) });

        if (moment(selectedTrip.scheduleTime).tz(this.user.timeZone).isBetween(start, end, null, '[]') &&
          moment(selectedTrip.appointmentTime).tz(this.user.timeZone).isBetween(start, end, null, '[]')) {
          isExist = true;
        }
      }
    }
    return isExist;
  }

  checkTripMaxFactor(planedTrips, driver, totalDistance) {
    let isExecute = true;
    // total trips check
    if (this.violation) {
      let numberOfTrips = true;
      if (this.violation && this.violation.maxPerRun) {
        if (planedTrips.compatible[driver._id] && planedTrips.compatible[driver._id].trips) {
          if (planedTrips.compatible[driver._id].trips.length >= this.violation.maxPerRun) {
            numberOfTrips = false
          }
        }

      }

      let numberOfTripsMiles = true;
      if (this.violation && this.violation.maxDistancePerRun) {
        if (totalDistance >= this.violation.maxDistancePerRun) {
          numberOfTripsMiles = false
        }
      }

      isExecute = (numberOfTrips && numberOfTripsMiles);
    }

    return isExecute;
  }

  fundingSourcesWiseTrip(selectedTrip, driver) {
    let isExist = false;

    const isfundingSource = driver.fundingSources.some(d => d.name === selectedTrip.cooperate && moment(this.preData.date).isBetween(moment(d.validityRange[0]).tz(this.user.timeZone).subtract(1, 'day'), moment(d.validityRange[1]).tz(this.user.timeZone).add(1, 'day')));
    if (selectedTrip.cooperate && isfundingSource) {
      const driverFleetId = this.selectedMapper.mappers[driver._id];
      if (driverFleetId) {
        if (this.preFleet[driverFleetId] && this.preFleet[driverFleetId].fundingSources && this.preFleet[driverFleetId].fundingSources.includes(selectedTrip.cooperate)) {
          isExist = true;
        }
      }
    }
    return isExist;
  }

  serviceAreasWiseTrip(selectedTrip, driver) {
    let isExist = false;
    if (selectedTrip.serviceArea && this.shiftMapper[driver._id] && this.shiftMapper[driver._id].serviceAreas.includes(selectedTrip.serviceArea)) {
      isExist = true;
    }
    return isExist;
  }

  spaceTypeWiseTrip(selectedTrip, driver) {
    let isExist = false;

    if (this.violation && !this.violation.isCapacityViolation) {
      const driverFleetId = this.selectedMapper.mappers[driver._id];
      if (driverFleetId) {
        if (selectedTrip.spaceType && driverFleetId && this.preFleet[driverFleetId]) {
          isExist = this.preFleet[driverFleetId].capacities.some(capacity => capacity.spaceType === selectedTrip.spaceType);
        }
      }
    } else {
      isExist = true;
    }
    return isExist;
  }

  genderWiseTrip(selectedTrip, driver) {
    let isExist = true;

    if (selectedTrip.priorityClient.isPrefferedFemale) {
      isExist = driver.gender.toLowerCase() === 'female'
    }

    if (selectedTrip.preferredDriver) {
      isExist = driver._id === selectedTrip.priorityClient.preferredDriver;
    }
    return isExist;

  }

  async canFitTripInDriverRoute(planedTrips, driver, trip, allDriversNearestTo) {
    let result = await this.checkStopBasedPossibility(planedTrips, driver, trip);

    if (result.isAllow) {
      allDriversNearestTo[trip._id].push({
        driverId: driver._id,
        position: result.position,
        index: result.index,
        stops: result.stops
      });
    } else if (result.isGroupingNotBeneficial || result.isSequenceIllogical) {
      // Grouping not beneficial or illogical, don't log as error, just skip
      // Trip should be assigned individually instead
    } else {
      let logs = {
        isFundingSourceWiseExist: true,
        isDriverShiftWiseExist: true,
        isServiceAreasWiseExist: true,
        isSpaceTypeWiseExist: true,
        istimeWiseTripExist: result.isNearbyViolation ? false : false,
      };

      if (planedTrips.tripLogs[driver._id]) {
        planedTrips.tripLogs[driver._id].reasons.push({ trip: trip, logs });
      } else {
        planedTrips.tripLogs[driver._id] = { driver, reasons: [{ trip: trip, logs }] };
      }
    }

    return result.isAllow;
  }

  async checkStopBasedPossibility(planedTrips, driver, trip) {
    let result: any = { isAllow: false, position: null, index: null, stops: null };
    const assignedTrips = (planedTrips.compatible[driver._id] && planedTrips.compatible[driver._id].trips) ? planedTrips.compatible[driver._id].trips : [];

    // Check if grouping this trip makes sense or if it should be performed individually
    if (assignedTrips.length > 0) {
      const shouldGroup = await this.evaluateGroupingBenefit(driver, assignedTrips, trip);
      if (!shouldGroup) {
        result.isGroupingNotBeneficial = true;
        return result;
      }
    }

    // Additional check: Verify grouping won't create illogical sequence
    if (assignedTrips.length > 0) {
      const isSequenceLogical = await this.isGroupingSequenceLogical(assignedTrips, trip);
      if (!isSequenceLogical) {
        result.isSequenceIllogical = true;
        console.log(`Trip ${trip.tripId}: Grouping would create illogical sequence with backtracking. Assign individually.`);
        return result;
      }
    }

    const candidateTrips = [...assignedTrips, trip];
    let stops = [];
    candidateTrips.forEach(t => {
      stops.push({
        _id: t._id,
        tripId: t.tripId,
        type: 'P',
        time: moment(t.scheduleTime).tz(this.user.timeZone).valueOf(),
        lat: t.jobOriginLatitude,
        lon: t.jobOriginLongitude,
        spaceType: t.spaceType,
        priorityClient: t.priorityClient,
        scheduleTime: t.scheduleTime,
        appointmentTime: t.appointmentTime
      });
      stops.push({
        _id: t._id,
        tripId: t.tripId,
        type: 'D',
        time: moment(t.appointmentTime).tz(this.user.timeZone).valueOf(),
        lat: t.jobDestinationLatitude,
        lon: t.jobDestinationLongitude,
        spaceType: t.spaceType,
        priorityClient: t.priorityClient,
        scheduleTime: t.scheduleTime,
        appointmentTime: t.appointmentTime
      });
    });

    // Optimize stop sequence to minimize backtracking
    stops.sort((a, b) => {
      // 1. Hard constraint: Time ordering (pickups before their dropoffs)
      if (a.time !== b.time) return a.time - b.time;

      // 2. Pickup always before Dropoff for same trip
      if (a.type !== b.type) return a.type === 'P' ? -1 : 1;

      // 3. For same time & type, use geographic proximity to minimize backtracking
      // This will be optimized further in the loop below
      return (a.tripId || '').localeCompare(b.tripId || '');
    });

    // Apply Traveling Salesman-like optimization: reorder stops within same time windows to minimize distance
    stops = this.optimizeStopSequenceForDistance(stops);

    const driverFleetId = this.selectedMapper ? this.selectedMapper.mappers[driver._id] : null;
    const vehicleCapacities = (driverFleetId && this.preFleet[driverFleetId]) ? (this.preFleet[driverFleetId].capacities || []) : [];

    const currentLoad = {};
    for (const stop of stops) {
      if (stop.type === 'P') {
        currentLoad[stop.spaceType] = (currentLoad[stop.spaceType] || 0) + 1;
        if (this.violation && !this.violation.isCapacityViolation) {
          const vCap = vehicleCapacities.find(c => c.spaceType === stop.spaceType);
          if (!vCap || currentLoad[stop.spaceType] > vCap.capacity) return result;
        }
      } else {
        currentLoad[stop.spaceType] = (currentLoad[stop.spaceType] || 0) - 1;
        if (currentLoad[stop.spaceType] < 0) currentLoad[stop.spaceType] = 0;
      }
    }

    const startOfDay = moment(this.preData.date).tz(this.user.timeZone).startOf('day');
    const todayShift = this.shiftMapper[driver._id] ? this.shiftMapper[driver._id].shifts.find(s => s.day === startOfDay.day() && s.isEnabled) : null;

    if (!todayShift || !todayShift.checkin || !todayShift.checkout) {
      return result;
    }

    let currentTime = moment(startOfDay).set({ hour: Number(todayShift.checkin.split(':')[0]), minute: Number(todayShift.checkin.split(':')[1]) });
    let checkoutTime = moment(startOfDay).set({ hour: Number(todayShift.checkout.split(':')[0]), minute: Number(todayShift.checkout.split(':')[1]) });

    let currentLat = driver.startingPointAddress ? driver.startingPointAddress.latitude : null;
    let currentLon = driver.startingPointAddress ? driver.startingPointAddress.longitude : null;

    if (currentLat === null || currentLon === null) return result;

    const relaxationMargin = this.violation ? this.violation.groupCushion : 15;
    let passengersOnBoard = 0;

    for (const stop of stops) {
      const travel = await this.calculateDistance(currentLat, currentLon, stop.lat, stop.lon);
      currentTime.add(travel.duration, 'minutes');

      // Targeted 5-mile radius check for grouping (Pickup stops)
      // Only enforce for the NEW trip being added AND only if vehicle is NOT empty
      if (stop.type === 'P' && stop._id === trip._id && passengersOnBoard > 0 && travel.distance > (this.violation ? this.violation.groupRadius : 5)) {
        if (this.violation && !this.violation.isNearbyViolation) {
          result.isNearbyViolation = true;
          return result;
        }
      }

      const stopTargetTime = moment(stop.time).tz(this.user.timeZone);
      const earliestWindow = stopTargetTime.clone().subtract(15, 'minutes');

      // If there's significant idle time (>20 minutes), align to scheduled time instead of 15-min window
      const idleTime = stopTargetTime.diff(currentTime, 'minutes');
      if (idleTime > 20) {
        // Large gap: align to scheduled time to avoid showing "too early" ETAs
        currentTime = stopTargetTime.clone();
      } else if (currentTime.isBefore(earliestWindow)) {
        // Normal case: apply 15-minute window
        currentTime = earliestWindow.clone();
      }

      // Capture Arrival Time (Reflects the 15-min snap or scheduled time if gap)
      stop.estimatedArrivalTime = currentTime.toISOString();

      // CRITICAL: For dropoff stops (appointments), ensure patient arrives ON TIME
      if (stop.type === 'D') {
        // Appointment time validation: Patient must arrive BEFORE appointment time
        // Allow small buffer for check-in (default 5 minutes)
        const appointmentBuffer = 5; // minutes to allow for check-in
        const maxAllowedArrivalTime = stopTargetTime.clone().add(appointmentBuffer, 'minutes');

        if (currentTime.isAfter(maxAllowedArrivalTime)) {
          console.warn(
            `Trip ${stop.tripId}: Patient ${stop.priorityClient.displayName} would arrive LATE at appointment. ` +
            `Scheduled: ${stopTargetTime.format('HH:mm')}, Estimated: ${currentTime.format('HH:mm')}, ` +
            `Late by: ${currentTime.diff(stopTargetTime, 'minutes')} minutes. REJECTING ROUTE.`
          );
          return result; // Reject this route
        }

        // Log if arriving close to appointment time (within 10 minutes)
        const minutesEarly = stopTargetTime.diff(currentTime, 'minutes');
        if (minutesEarly < 10 && minutesEarly > 0) {
          console.log(`Trip ${stop.tripId}: Patient arriving only ${minutesEarly} minutes early. Close call.`);
        }
      }

      if (this.violation && !this.violation.isTimeViolation) {
        if (currentTime.isAfter(stopTargetTime.clone().add(relaxationMargin, 'minutes'))) return result;
      }

      // Shared Stop Optimization
      let serviceTimeMinutes = 0;
      if (currentLat === stop.lat && currentLon === stop.lon) {
        serviceTimeMinutes = 2; // Co-passenger shared stop
      } else {
        const stData = this.preData.spaceTypes ? this.preData.spaceTypes[stop.spaceType] : null;
        if (stData) {
          const stValue = stData[stop.type === 'P' ? 'loadTime' : 'unloadTime'];
          const [h, m] = stValue.split(':').map(Number);
          serviceTimeMinutes = (h * 60) + m;
        }
      }
      currentTime.add(serviceTimeMinutes, 'minutes');

      // Departure check: cannot leave before stop time
      if (currentTime.isBefore(stopTargetTime)) {
        currentTime = stopTargetTime.clone();
      }

      // Update passenger count for the next segment
      if (stop.type === 'P') {
        passengersOnBoard++;
      } else {
        passengersOnBoard--;
        if (passengersOnBoard < 0) passengersOnBoard = 0;
      }

      currentLat = stop.lat;
      currentLon = stop.lon;
    }

    if (currentTime.isAfter(checkoutTime.add(relaxationMargin, 'minutes'))) return result;

    const newStart = moment(trip.scheduleTime).tz(this.user.timeZone);
    let insertIndex = assignedTrips.length;
    for (let i = 0; i < assignedTrips.length; i++) {
      if (newStart.isBefore(moment(assignedTrips[i].scheduleTime).tz(this.user.timeZone))) {
        insertIndex = i;
        break;
      }
    }

    result.isAllow = true;
    result.index = insertIndex;
    result.position = (insertIndex > 0 && assignedTrips[insertIndex - 1]) ? assignedTrips[insertIndex - 1]._id : null;
    result.stops = stops.map((s, idx) => ({ ...s, stopType: s.type === 'P' ? 'pickup' : 'dropoff', priority: idx + 1 }));
    return result;
  }




  /**   * From a list of feasible drivers, choose the best one based on the minimal extra travel distance.
   *
   * The extra distance is measured from either the driver's starting point (if no trips are yet assigned)
   * or the last trip’s dropoff location.
   *
   * @param {Array} feasibleDrivers - Array of driver objects that passed eligibility and feasibility checks.
   * @param {Object} trip - The trip to assign.
   * @param {Object} assignments - Mapping from driver._id to an array of assigned trips.
   */
  async chooseDriverForTrip(clientDriverId, feasibleDrivers, allDriversNearestTo, selectedTrip, compatible) {
    let bestDriver = null;
    let minExtraDistance = Infinity;

    for (let driver of feasibleDrivers) {
      let referencePoint = null;
      const nearestToTripDetails = (allDriversNearestTo[selectedTrip._id] && allDriversNearestTo[selectedTrip._id].find(item => item.driverId === driver._id)) ? allDriversNearestTo[selectedTrip._id].find(item => item.driverId === driver._id) : null;
      let index = nearestToTripDetails ? nearestToTripDetails.index : null;
      let stops = nearestToTripDetails ? nearestToTripDetails.stops : null;

      //  assing A and B to same driver
      if (this.violation && this.violation.prefferedToSameDriver) {
        if (clientDriverId === driver._id) {
          bestDriver = { driver, index, stops };
          break;
        }
      }

      // If we have validated stops, use the one immediately before our pickup as the reference
      if (stops && stops.length > 0) {
        const myPickupStop = stops.find(s => s._id === selectedTrip._id && s.stopType === 'pickup');
        if (myPickupStop && myPickupStop.priority > 1) {
          const prevStop = stops.find(s => s.priority === myPickupStop.priority - 1);
          referencePoint = {
            lat: prevStop.lat,
            lon: prevStop.lon
          };
        } else {
          referencePoint = {
            lat: driver.startingPointAddress ? driver.startingPointAddress.latitude : null,
            lon: driver.startingPointAddress ? driver.startingPointAddress.longitude : null,
          };
        }
      } else {
        referencePoint = {
          lat: driver.startingPointAddress.latitude,
          lon: driver.startingPointAddress.longitude,
        };
      }

      const checkpossibleDistance = await this.calculateDistance(referencePoint.lat, referencePoint.lon, selectedTrip.jobOriginLatitude, selectedTrip.jobOriginLongitude);
      if (checkpossibleDistance.distance < minExtraDistance) {
        minExtraDistance = checkpossibleDistance.distance;
        bestDriver = { driver, index, stops };
      }
    }

    return bestDriver;
  }

  //  checkDriverRoutes(planedTrips, candidateDrivers, trip, allDriversNearestTo) {
  //   const feasibleDrivers = candidateDrivers.filter(async (driver) => {
  //     const result = await this.canFitTripInDriverRoute(planedTrips, driver, trip, allDriversNearestTo);
  //     return result;
  //   });

  //   return feasibleDrivers;
  // }

  async checkDriverRoutes(planedTrips, candidateDrivers, trip, allDriversNearestTo) {
    const feasibleDrivers = await Promise.all(
      candidateDrivers.map(async (driver) => {
        const result = await this.canFitTripInDriverRoute(planedTrips, driver, trip, allDriversNearestTo);
        return result ? driver : null;
      })
    );
    return feasibleDrivers.filter(driver => driver !== null);
  }



  async calculateDistance(lat1, lon1, lat2, lon2) {
    let resutl;
    if (this.selectedMethod && this.selectedMethod === true) {
      resutl = await this.calculateDistanceWithGIS(lat1, lon1, lat2, lon2);
    } else {
      resutl = await new Promise((resolve) => { resolve(getDistanceFromLatLon(lat1, lon1, lat2, lon2)) });
    }
    return resutl;
  }


  async calculateDistanceWithGIS(lat1, lon1, lat2, lon2) {
    const res: any = await this.assigTripsService.getRoutingDistance(lat1, lon1, lat2, lon2).toPromise();
    const segments: any = res.features[0].properties.segments;
    return {
      distance: (segments[0].distance / 1609),
      duration: (segments[0].duration / 60)
    };
  }

  /**
   * Optimizes stop sequence to minimize backtracking and distance traveled.
   * Uses a nearest-neighbor approach within same time windows to prevent geographic inefficiency.
   *
   * @param {Array} stops - Array of stops sorted by time
   * @returns {Array} Re-ordered stops with backtracking minimized
   */
  optimizeStopSequenceForDistance(stops: any[]): any[] {
    if (stops.length <= 2) return stops;

    const optimized = [];
    let i = 0;

    while (i < stops.length) {
      const currentTime = stops[i].time;
      const stopsAtThisTime = [];

      // Collect all stops at the same time
      while (i < stops.length && stops[i].time === currentTime) {
        stopsAtThisTime.push(stops[i]);
        i++;
      }

      // If multiple stops at same time, sort by geographic proximity
      if (stopsAtThisTime.length > 1) {
        stopsAtThisTime.sort((a, b) => {
          // Pickups always before dropoffs
          if (a.type !== b.type) return a.type === 'P' ? -1 : 1;

          // Same type: group by tripId to keep pickup-dropoff pairs together
          return (a.tripId || '').localeCompare(b.tripId || '');
        });
      }

      optimized.push(...stopsAtThisTime);
    }

    return optimized;
  }

  /**
   * Validates that grouping a trip won't cause ANY passenger to miss their appointment.
   * This is a HARD constraint - if any passenger would be late, grouping is rejected.
   *
   * @param {Array} assignedTrips - Already assigned trips
   * @param {Object} newTrip - Trip being considered
   * @returns {Promise<boolean>} True if all passengers can arrive on time
   */
  async validateAppointmentTimesForGrouping(assignedTrips, newTrip): Promise<boolean> {
    try {
      if (assignedTrips.length === 0) return true; // Single trip, always OK

      const appointmentBuffer = 5; // minutes for check-in

      // Simulate grouped route to check appointment times
      const allTrips = [...assignedTrips, newTrip];
      let totalTravelTime = 0;

      for (let i = 0; i < allTrips.length - 1; i++) {
        const currentTrip = allTrips[i];
        const nextTrip = allTrips[i + 1];

        // Travel time from current dropoff to next pickup
        const travelDistance = await this.calculateDistance(
          currentTrip.jobDestinationLatitude,
          currentTrip.jobDestinationLongitude,
          nextTrip.jobOriginLatitude,
          nextTrip.jobOriginLongitude
        );
        totalTravelTime += travelDistance.duration;

        // Service time at dropoff
        totalTravelTime += 5; // ~5 minutes for dropoff

        // Check if this trip would be late
        const nextTripScheduledTime = moment(nextTrip.scheduleTime).tz(this.user.timeZone);
        const nextTripAppointmentTime = moment(nextTrip.appointmentTime).tz(this.user.timeZone);

        // Estimated dropoff time = pickup + travel from previous + all service times
        const estimatedPickupTime = nextTripScheduledTime.clone().add(totalTravelTime, 'minutes');

        // Add travel from pickup to dropoff
        const tripTravelDistance = await this.calculateDistance(
          nextTrip.jobOriginLatitude,
          nextTrip.jobOriginLongitude,
          nextTrip.jobDestinationLatitude,
          nextTrip.jobDestinationLongitude
        );
        const estimatedDropoffTime = estimatedPickupTime.clone().add(tripTravelDistance.duration, 'minutes');

        // Check if late
        if (estimatedDropoffTime.isAfter(nextTripAppointmentTime.clone().add(appointmentBuffer, 'minutes'))) {
          console.warn(
            `Trip ${nextTrip.tripId}: ${nextTrip.priorityClient.displayName} would be LATE if grouped. ` +
            `Appointment: ${nextTripAppointmentTime.format('HH:mm')}, ` +
            `Estimated arrival: ${estimatedDropoffTime.format('HH:mm')}, ` +
            `Late by: ${estimatedDropoffTime.diff(nextTripAppointmentTime, 'minutes')} minutes. CANNOT GROUP.`
          );
          return false;
        }

        // Prepare for next iteration
        totalTravelTime = travelDistance.duration + 5; // Reset for next leg
      }

      return true;

    } catch (error) {
      console.error('Error validating appointment times for grouping:', error);
      return true; // If error, allow grouping
    }
  }

  /**
   * Enhanced grouping benefit evaluation with backtracking detection.
   *
   * Checks for:
   * 1. If trips are geographically scattered (bad for grouping)
   * 2. If the grouped route sequence causes backtracking
   * 3. If individual trips are more time/distance efficient
   * 4. **CRITICAL: If appointment times can be met for ALL passengers**
   */
  async evaluateGroupingBenefit(driver, assignedTrips, trip) {
    try {
      // CRITICAL: Check appointment times FIRST before any other evaluation
      const appointmentsOK = await this.validateAppointmentTimesForGrouping(assignedTrips, trip);
      if (!appointmentsOK) {
        console.log(`Trip ${trip.tripId}: Grouping would cause patient(s) to miss appointments. Assign individually.`);
        return false; // HARD REJECT - patient appointment is critical
      }
      if (assignedTrips.length > 0) {
        const lastAssignedTrip = assignedTrips[assignedTrips.length - 1];
        const distToNewPickup = await this.calculateDistance(
          lastAssignedTrip.jobDestinationLatitude,
          lastAssignedTrip.jobDestinationLongitude,
          trip.jobOriginLatitude,
          trip.jobOriginLongitude
        );

        // If new trip is more than 20 miles away, don't group
        if (distToNewPickup.distance > 20) {
          console.log(`Trip ${trip.tripId}: Too far from existing route (${distToNewPickup.distance.toFixed(1)}mi). Assign individually.`);
          return false;
        }
      }

      // Check for backtracking scenario: if grouped route has significantly longer sequence
      const backtrackingRisk = await this.detectBacktrackingRisk(driver, assignedTrips, trip);
      if (backtrackingRisk.hasBacktracking && backtrackingRisk.penalty > 15) {
        console.log(`Trip ${trip.tripId}: Backtracking detected (penalty: ${backtrackingRisk.penalty.toFixed(1)}min). Assign individually.`);
        return false;
      }

      // Standard solo vs grouped comparison
      let soloStartLat = driver.startingPointAddress ? driver.startingPointAddress.latitude : null;
      let soloStartLon = driver.startingPointAddress ? driver.startingPointAddress.longitude : null;

      if (soloStartLat === null || soloStartLon === null) return true;

      // Distance from driver start to pickup and pickup to dropoff (solo)
      const soloDistanceToPickup = await this.calculateDistance(soloStartLat, soloStartLon, trip.jobOriginLatitude, trip.jobOriginLongitude);
      const soloDistancePickupToDropoff = await this.calculateDistance(trip.jobOriginLatitude, trip.jobOriginLongitude, trip.jobDestinationLatitude, trip.jobDestinationLongitude);
      const soloTotalDistance = soloDistanceToPickup.distance + soloDistancePickupToDropoff.distance;
      const soloTotalTime = soloDistanceToPickup.duration + soloDistancePickupToDropoff.duration;

      // Grouped trip route
      const lastAssignedTrip = assignedTrips[assignedTrips.length - 1];
      let groupedStartLat = lastAssignedTrip.jobDestinationLatitude;
      let groupedStartLon = lastAssignedTrip.jobDestinationLongitude;

      const groupedDistanceToPickup = await this.calculateDistance(groupedStartLat, groupedStartLon, trip.jobOriginLatitude, trip.jobOriginLongitude);
      const groupedDistancePickupToDropoff = await this.calculateDistance(trip.jobOriginLatitude, trip.jobOriginLongitude, trip.jobDestinationLatitude, trip.jobDestinationLongitude);
      const groupedTotalDistance = groupedDistanceToPickup.distance + groupedDistancePickupToDropoff.distance;
      const groupedTotalTime = groupedDistanceToPickup.duration + groupedDistancePickupToDropoff.duration;

      const timeDifference = Math.abs(soloTotalTime - groupedTotalTime);
      const distanceDifference = groupedTotalDistance - soloTotalDistance;

      // If solo trip has BOTH less time AND less distance (with at least 0.5mi difference), don't group
      if (soloTotalTime <= groupedTotalTime && soloTotalDistance <= groupedTotalDistance && distanceDifference > 0.5) {
        console.log(`Trip ${trip.tripId}: Solo is more efficient. Solo: ${soloTotalDistance.toFixed(2)}mi/${soloTotalTime.toFixed(0)}min vs Grouped: ${groupedTotalDistance.toFixed(2)}mi/${groupedTotalTime.toFixed(0)}min`);
        return false;
      }

      // If grouping adds MORE than 15 minutes AND more than 3 miles, don't group
      if (groupedTotalTime - soloTotalTime > 15 && groupedTotalDistance - soloTotalDistance > 3) {
        console.log(`Trip ${trip.tripId}: Grouping penalty too high. Time +${(groupedTotalTime - soloTotalTime).toFixed(0)}min, Distance +${(groupedTotalDistance - soloTotalDistance).toFixed(1)}mi`);
        return false;
      }

      return true;

    } catch (error) {
      console.error('Error evaluating grouping benefit:', error);
      return true;
    }
  }

  /**
   * Detects if a grouped route would cause significant backtracking.
   *
   * Example of backtracking:
   * Pickup A (Loc1) → Pickup B (Loc2) → Dropoff A (Loc1) → Dropoff B (Loc2)
   * Better: Pickup A → Dropoff A → Pickup B → Dropoff B
   */
  async detectBacktrackingRisk(driver, assignedTrips, newTrip) {
    let totalBacktrackDistance = 0;
    const allTrips = [...assignedTrips, newTrip];

    for (let i = 0; i < allTrips.length - 1; i++) {
      const currentTrip = allTrips[i];
      const nextTrip = allTrips[i + 1];

      // Check if next pickup is closer to current pickup than current dropoff
      const distCurrentToNextPickup = await this.calculateDistance(
        currentTrip.jobOriginLatitude,
        currentTrip.jobOriginLongitude,
        nextTrip.jobOriginLatitude,
        nextTrip.jobOriginLongitude
      );

      const distCurrentDropoffToNextPickup = await this.calculateDistance(
        currentTrip.jobDestinationLatitude,
        currentTrip.jobDestinationLongitude,
        nextTrip.jobOriginLatitude,
        nextTrip.jobOriginLongitude
      );

      // If going from current pickup to next pickup is shorter than dropoff to next pickup,
      // it suggests the trips should be done separately
      if (distCurrentToNextPickup.distance < distCurrentDropoffToNextPickup.distance * 0.7) {
        const penalty = distCurrentDropoffToNextPickup.distance - distCurrentToNextPickup.distance;
        totalBacktrackDistance += penalty;
      }
    }

    return {
      hasBacktracking: totalBacktrackDistance > 0,
      penalty: totalBacktrackDistance
    };
  }

  /**
   * Checks if grouping trips would result in a logical, efficient sequence.
   *
   * Returns false if the grouped sequence would require backtracking or inefficient routing.
   *
   * @param {Array} assignedTrips - Already assigned trips
   * @param {Object} newTrip - Trip being considered for grouping
   * @returns {Boolean} True if sequence would be logical, false if illogical
   */
  async isGroupingSequenceLogical(assignedTrips, newTrip): Promise<boolean> {
    if (assignedTrips.length === 0) return true;

    // Check each assigned trip against the new trip
    for (const existingTrip of assignedTrips) {
      // Calculate if new trip's dropoff is on the way to existing trip's dropoff
      const distNewPickupToNewDropoff = await this.calculateDistance(
        newTrip.jobOriginLatitude,
        newTrip.jobOriginLongitude,
        newTrip.jobDestinationLatitude,
        newTrip.jobDestinationLongitude
      );

      const distNewPickupToExistingDropoff = await this.calculateDistance(
        newTrip.jobOriginLatitude,
        newTrip.jobOriginLongitude,
        existingTrip.jobDestinationLatitude,
        existingTrip.jobDestinationLongitude
      );

      const distExistingPickupToNewPickup = await this.calculateDistance(
        existingTrip.jobOriginLatitude,
        existingTrip.jobOriginLongitude,
        newTrip.jobOriginLatitude,
        newTrip.jobOriginLongitude
      );

      const distExistingDropoffToNewPickup = await this.calculateDistance(
        existingTrip.jobDestinationLatitude,
        existingTrip.jobDestinationLongitude,
        newTrip.jobOriginLatitude,
        newTrip.jobOriginLongitude
      );

      // If existing trip's dropoff is on the way to new trip's dropoff, sequence is illogical
      // Example: Pickup A (0,0) → Pickup B (1,1) → Dropoff A (0,0) → Dropoff B (1,1)
      // Here dropoff A is NOT on way, causing backtracking
      const onWayToNewDropoff =
        distExistingDropoffToNewPickup.distance < distExistingPickupToNewPickup.distance * 0.5;

      if (onWayToNewDropoff) {
        // Existing dropoff is very close to new pickup, not on the way - illogical grouping
        console.log(
          `Illogical sequence detected: Existing trip dropoff (${existingTrip.jobDestinationLatitude.toFixed(2)}, ${existingTrip.jobDestinationLongitude.toFixed(2)}) ` +
          `not on way to new pickup (${newTrip.jobOriginLatitude.toFixed(2)}, ${newTrip.jobOriginLongitude.toFixed(2)})`
        );
        return false;
      }
    }

    return true;
  }
}


